module.exports = __webpack_public_path__ + "img/laundry-room.59be1c7b.svg";